module.exports = __webpack_public_path__ + "img/mobile-help-1.33592916.jpg";